import React, { Component } from "react";
import "./sidenav.css";
import ReactDOM from 'react-dom';
import Body from '../body/body.js';

class SideNav extends Component {
	handleClickMath = (mathItem) => {
		 var name = this.props.objMath[mathItem].name;
		 var code = this.props.objMath[mathItem].code;
		 var desc = this.props.objMath[mathItem].desc;
		 if( name && code !== undefined ) {
			 ReactDOM.render(<Body name={name} code={code} desc={desc}/>, document.getElementById('root'));
		 }
		 else{
			 return;
		 }
	}
	handleClickArr = (arrItem) => {
		 var name = this.props.objArr[arrItem].name;
		 var code = this.props.objArr[arrItem].code;
		 var desc = this.props.objArr[arrItem].desc;
		 if( name && code !== undefined ) {
			 ReactDOM.render(<Body name={name} code={code} desc={desc}/>, document.getElementById('root'));
		 }
		 else{
			 ReactDOM.render(<Body name={"An error occurred!"} code={"undefined"}/>, document.getElementById('root'));
		 }
	}
	handleClickObj = (objItem) => {
		 var name = this.props.objObject[objItem].name;
 		 var code = this.props.objObject[objItem].code;
		 var desc = this.props.objObject[objItem].desc;
		 if( name && code !== undefined ) {
			 ReactDOM.render(<Body name={name} code={code} desc={desc}/>, document.getElementById('root'));
		 }
		 else{
			 ReactDOM.render(<Body name={"An error occurred!"} code={"undefined"}/>, document.getElementById('root'));
		 }
	}
	render() {
		ReactDOM.render(<Body name={"The Mathf Documentation!"} desc={"Thanks for visiting the documentation for the Mathf."}
			code={"If you like the library and want to help in one form or another,\nview our github repo!"}/>, document.getElementById('root'));
		return(
			<div>
				<div className="sideNav">
					<div className="head" id="head">
						<h1 className="headFnt">MATHF</h1>
					</div>
					<div className="contents">
						<h1 className="ulHeadFont" data-toggle="collapse" data-target="#arr"> Arrays </h1>
						<div id="arr" className="collapse in">
							<ul className="ulFont">
								{
									this.props.arrItems.map((arrItem => {
										return <li onClick={e => this.handleClickArr(arrItem)}>{arrItem}</li>
								}))
								}
							</ul>
						</div>

						<h1 className="ulHeadFont" data-toggle="collapse" data-target="#math"> Math </h1>
						<div id="math" className="collapse">
							<ul className="ulFont">
								{
									this.props.mathItems.map(mathItem => {
										return <li onClick={e => this.handleClickMath(mathItem)}>{mathItem}</li>
									})
								}
							</ul>
						</div>

						<h1 className="ulHeadFont" data-toggle="collapse" data-target="#obj"> Objects </h1>
						<div id="obj" className="collapse">
							<ul className="ulFont">
								{
									this.props.objItems.map((objItem => {
										return <li onClick={e => this.handleClickObj(objItem)}>{objItem}</li>
								}))
								}
							</ul>
						</div>

					</div>
				</div>
			</div>
		);
	}
}

export default SideNav



// WEBPACK FOOTER //
// ./src/components/sidenav/sidenav.js